<!-- use tags -->

import Layout1 from "../../src/routes/_index/+layout.marko";
import Page from "../../src/routes/_index/newsletter/+page.marko";

<Layout1>
	<Page/>
</>
